module.exports = "/assets/b51c88a3a5dcca2122e2f246ce3d628a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/KN.png
// module id = 2675
// module chunks = 0